import { useState } from "react";
import { useTranslation } from 'react-i18next';


function StarRating({ count }) {
    return (
        <div className="flex gap-0.5">
            {[...Array(count)].map((_, i) => (
                <svg
                    key={i}
                    className="w-4 h-4 text-[#ab8f58] fill-current"
                    viewBox="0 0 24 24"
                >
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                </svg>
            ))}
        </div>
    );
}

const HotelsCarousel = () => {
    const { t } = useTranslation();
    const [currentIndex, setCurrentIndex] = useState(0);
    const itemsPerPage = 3;

    const nextSlide = () => {
        setCurrentIndex((prev) =>
            prev + itemsPerPage >= hotels.length ? 0 : prev + itemsPerPage
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prev) =>
            prev - itemsPerPage < 0 ? Math.max(0, hotels.length - itemsPerPage) : prev - itemsPerPage
        );
    };

    return (
        <div className="o-cont-fullw">
            <div className="container">
                <h2 className="mt-8 mb-4 text-center h3 mb-md-6">Explora nuestros hoteles</h2>
                <c-swiper-hotels>
                    <div init="false" className="c-swiper-hotels" style={{ display: "inline-flex" }}>
                        <swiper-slide style={{ width: "437.333px", marginRight: "16px" }} role="group" aria-label="1 / 6">
                            <div className="c-card-hotel">
                                <figure className="c-card-hotel_img">
                                    <img className="img" alt="Piscina" title="Piscina" src="https://pro-static.h10hotels.com/gallery/T11D3/01_OBSPool.jpg" />
                                </figure>
                                <div className="c-card-hotel_body">
                                    <h3 className="text-uppercase">Ocean Blue &amp; Sand</h3>
                                    <div className="o-stars">
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>

                                    </div>
                                    <p className="mb-1">
                                        <span className="o-icon">
                                            <i className="fa-solid fa-locarion-dot"></i>
                                        </span> Punta Cana
                                    </p>
                                    <p className="c-card-hotel_price">Desde <strong className="text-md fw-semibold text-primary">$ 243</strong>/ noche </p>
                                    <button type="button" className="btn btn-primary">Ver disponibilidad</button>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide style={{ width: "437.333px", marginRight: "16px" }} role="group" aria-label="2 / 6">
                            <div className="c-card-hotel">
                                <figure className="c-card-hotel_img">
                                    <img className="img" alt="Vista general del hotel" title="Vista general del hotel" src="https://pro-static.h10hotels.com/gallery/T11D3/01_OCSHotel1.jpg" />
                                </figure>
                                <div className="c-card-hotel_body">
                                    <h3 className="text-uppercase">Ocean Coral Spring</h3>
                                    <div className="o-stars">
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>

                                    </div>
                                    <p className="mb-1">
                                        <span className="o-icon">
                                            <i className="fa-solid fa-locarion-dot"></i>
                                        </span> Jamaica
                                    </p>
                                    <p className="c-card-hotel_price">Desde <strong className="text-md fw-semibold text-primary">$ 377</strong>/ noche </p>
                                    <button type="button" className="btn btn-primary">Ver disponibilidad</button>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide style={{ width: "437.333px", marginRight: "16px" }} role="group" aria-label="3 / 6">
                            <div className="c-card-hotel">
                                <figure className="c-card-hotel_img">
                                    <img className="img" alt="Piscina " title="Piscina " src="https://pro-static.h10hotels.com/gallery/T11D3/13_OCTSwimmingPool7.jpg" />
                                </figure>
                                <div className="c-card-hotel_body">
                                    <h3 className="text-uppercase">Ocean Coral &amp; Turquesa</h3>
                                    <div className="o-stars">
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>

                                    </div>
                                    <p className="mb-1">
                                        <span className="o-icon">
                                            <i className="fa-solid fa-locarion-dot"></i>
                                        </span> Riviera Maya
                                    </p>
                                    <p className="c-card-hotel_price">Desde <strong className="text-md fw-semibold text-primary">$ 248</strong>/ noche </p>
                                    <button type="button" className="btn btn-primary">Ver disponibilidad</button>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide style={{ width: "437.333px", marginRight: "16px" }} role="group" aria-label="4 / 6">
                            <div className="c-card-hotel">
                                <figure className="c-card-hotel_img">
                                    <img className="img" alt="The One Alma Paris" title="The One Alma Paris" src="https://pro-static.h10hotels.com/gallery/T11D3/09_TAPBreakfast.jpg" />
                                </figure>
                                <div className="c-card-hotel_body">
                                    <h3 className="text-uppercase">The One Alma Paris</h3>
                                    <div className="o-stars">
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>

                                    </div>
                                    <p className="mb-1">
                                        <span className="o-icon">
                                            <i className="fa-solid fa-locarion-dot"></i>
                                        </span> París
                                    </p>
                                    <p className="c-card-hotel_price">Desde <strong className="text-md fw-semibold text-primary">402 €</strong>/ noche </p>
                                    <button type="button" className="btn btn-primary">Ver disponibilidad</button>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide style={{ width: "437.333px", marginRight: "16px" }} role="group" aria-label="5 / 6">
                            <div className="c-card-hotel">
                                <figure className="c-card-hotel_img">
                                    <img className="img" alt="Habitación Standard" title="Habitación Standard" src="https://pro-static.h10hotels.com/gallery/T11D3/01_HRCStandard1.jpg" />
                                </figure>
                                <div className="c-card-hotel_body">
                                    <h3 className="text-uppercase">H10 Roma Città</h3>
                                    <div className="o-stars">
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>

                                    </div>
                                    <p className="mb-1">
                                        <span className="o-icon">
                                            <i className="fa-solid fa-locarion-dot"></i>
                                        </span> Roma
                                    </p>
                                    <p className="c-card-hotel_price">Desde <strong className="text-md fw-semibold text-primary">185 €</strong>/ noche </p>
                                    <button type="button" className="btn btn-primary">Ver disponibilidad</button>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide style={{ width: "437.333px", marginRight: "16px" }} role="group" aria-label="6 / 6">
                            <div className="c-card-hotel">
                                <figure className="c-card-hotel_img">
                                    <img className="img" alt="Piscina Privilege" title="Piscina Privilege" src="https://pro-static.h10hotels.com/gallery/T11D3/09_HRPPrivilegePoolNight.jpg" />
                                </figure>
                                <div className="c-card-hotel_body">
                                    <h3 className="text-uppercase">H10 Rubicón Horizons Collection</h3>
                                    <div className="o-stars">
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>
                                        <span className="o-icon text-categoria">
                                            <i className="fa-solid fa-star"></i>
                                        </span>

                                    </div>
                                    <p className="mb-1">
                                        <span className="o-icon">
                                            <i className="fa-solid fa-locarion-dot"></i>
                                        </span> Lanzarote
                                    </p>
                                    <p className="c-card-hotel_price">Desde <strong className="text-md fw-semibold text-primary">200 €</strong>/ noche </p>
                                    <button type="button" className="btn btn-primary">Ver disponibilidad</button>
                                </div>
                            </div>
                        </swiper-slide>

                    </div>
                </c-swiper-hotels>
            </div>
        </div>
    );
}

export default HotelsCarousel;
